import React from 'react'

const styl = {
  'width': '400px'
}

class DailyWorkSheetSummary extends React.Component {
  render () {
    return (
      <div style={styl}>
        <h2>Daily Work Sheet Summary</h2>
        <ul>
          <li>
            <h3>In Progress</h3>
            <ul>
              <li>
                <h4>Marriot World Center</h4>
                <p>
                  lorem ipsum some other stuff I dont remember dolar sat
                </p>
              </li>
              <li>
                <h4>Marriot World Center</h4>
                <p>
                  lorem ipsum some other stuff I dont remember dolar sat
                </p>
              </li>
            </ul>
          </li>
          <li>
            <h3>Pending Approval</h3>
            <ul>
              <li>
                <h4>Marriot World Center</h4>
                <p>
                  lorem ipsum some other stuff I dont remember dolar sat
                </p>
              </li>
            </ul>
          </li>
          <li>
            <h3>Archive</h3>
            <ul>
              <li>
                <h4>Marriot World Center</h4>
                <p>
                  lorem ipsum some other stuff I dont remember dolar sat
                </p>
              </li>
              <li>
                <h4>Marriot World Center</h4>
                <p>
                  lorem ipsum some other stuff I dont remember dolar sat
                </p>
              </li>
              <li>
                <h4>Marriot World Center</h4>
                <p>
                  lorem ipsum some other stuff I dont remember dolar sat
                </p>
              </li>
              <li>
                <h4>Marriot World Center</h4>
                <p>
                  lorem ipsum some other stuff I dont remember dolar sat
                </p>
              </li>
            </ul>
          </li>
        </ul>
        <h2>Daily Work Sheet Summary</h2>
        <ul>
          <li>
            <h3>In Progress</h3>
            <ul>
              <li>
                <h4>Marriot World Center</h4>
                <p>
                  lorem ipsum some other stuff I dont remember dolar sat
                </p>
              </li>
              <li>
                <h4>Marriot World Center</h4>
                <p>
                  lorem ipsum some other stuff I dont remember dolar sat
                </p>
              </li>
            </ul>
          </li>
          <li>
            <h3>Pending Approval</h3>
            <ul>
              <li>
                <h4>Marriot World Center</h4>
                <p>
                  lorem ipsum some other stuff I dont remember dolar sat
                </p>
              </li>
            </ul>
          </li>
          <li>
            <h3>Archive</h3>
            <ul>
              <li>
                <h4>Marriot World Center</h4>
                <p>
                  lorem ipsum some other stuff I dont remember dolar sat
                </p>
              </li>
              <li>
                <h4>Marriot World Center</h4>
                <p>
                  lorem ipsum some other stuff I dont remember dolar sat
                </p>
              </li>
              <li>
                <h4>Marriot World Center</h4>
                <p>
                  lorem ipsum some other stuff I dont remember dolar sat
                </p>
              </li>
              <li>
                <h4>Marriot World Center</h4>
                <p>
                  lorem ipsum some other stuff I dont remember dolar sat
                </p>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    )
  }
}

export default DailyWorkSheetSummary



// WEBPACK FOOTER //
// ./src/components/daily-work-sheet-summary.js